(ns dashboard.components.profile
  (:require
   [reagent.core :as reagent]
   [dashboard.utils :refer [listen]]
   [dashboard.subs :as subs]))

(defn display-user-fullname [user]
  (if (= (listen ::subs/locale) :ja)
    (str (:lastNameJp user) " " (:firstNameJp user))
    (str (:firstName user) " " (:lastName user))))

(defn profile-img
  [{:keys [src text alt class]
    :or {class "h-10 w-10"}}]
  [:div
   (if (some? src)
     [:img.rounded-full
      {:alt alt
       :class class
       :src src}]
     [:span.inline-flex.items-center.justify-center.rounded-full.bg-gray-50.font-semibold
      {:class class}
      text])])

(defn user-profile-img
  [{:keys [user class]}]
  [profile-img
   {:class class
    :text (if (some? (:lastNameJp user))
            (:lastNameJp user)
            (str (first (:firstName user))
                 (first (:lastName user))))
    :src (:profile_picture_url user)
    :alt (display-user-fullname user)}])
